<template>
<div class="base">
    <div class="base-top">
        <!-- <div class="base-img"  :style="'background-image:url('+ coverPhoto.url+')'"></div> -->
         <div class="base-img" ></div>
        <div class="base-desc">
            <div  class="base-desc-top">
                <div class="red-icon">
                    <span>专题</span>
                </div>
                <p>最美2B应用专题</p>
            </div>
            <div  class="base-desc-line"></div>
            <div  class="base-context">
                随着云计算技术的普及，很多优秀的商早就将自己的软件旧貌换新颜了，
                并做出了很多惊艳的体验为2018年UEclub的常驻内容，
                将按照每月一期的方式 并做出了很多惊艳的体验为2018年UEclub的常驻内容，
                将按照每月一期的方式
            </div>
            <div  class="base-desc-amount">
                <div class="article-amount">
                    <p>13</p>
                    <p>篇文章</p>
                </div>
                <div class="see-amount">
                    <p>29676</p>
                    <p>位观众</p>
                </div>
            </div>
        </div>
    </div>
    <div class="base-center">
        <p>全部文章</p>
        <div class="base-line"></div>
    </div>
    <div class="base-bottom">
        <div class="article-list">
             <div class="post-card-box">
                <div class="post-cards">
                    <PostCard v-for="item in postList.posts" :key="item._id" :post="item" />
                </div>
            </div>
        </div>
        <div class="base-bottom-right">
            <p>热门评论</p>
            <div class="hot-comment">
               <HotCommentList></HotCommentList>
            </div>
        </div>
    </div>
</div>
    
</template>

<script>
import PostCard from '@/components/post/PostCard'
import HotCommentList from '@/components/common/HotCommentList.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
 name:"Base",
  data () {
    return {
       ca: '',
       coverPhoto:{
           url:"../assets/img/base.png",
       }
    }
  },
 components: {
    PostCard, HotCommentList
  },
 computed: {
    ...mapGetters('post', ['postList']),
  },
 created () {
    this.ca = '591e5fb0d82529145405981f';
    this.getPostList({ca: '591e5fb0d82529145405981f'});
  },
  methods:{
   ...mapActions('post', ['getPostList']),
  }
}
</script>
<style lang="scss">
.base{
    >.base-top{
        display: flex;
        flex-direction: row;
        padding-top: 40px;
       >.base-img{
         width: 404px;
         height: 182px;
        //  border: 1px solid wheat;
         border-radius:6px;
         background-image: url("../assets/img/base.png");
         background-size: cover;
       }
       >.base-desc{
         width: 749px;
         height: 182px;
         margin-left: 27px;
         >.base-desc-top{
              display: flex;
             flex-direction: row;
            >.red-icon{
                width:66px;
                height:24px;
                background:rgba(231,0,18,1);
                border-radius:2px;
                padding-top: 3px;
                margin-top: 4px;

               >span{
                   font-size:14px;
                    font-family:MicrosoftYaHei-Bold;
                    font-weight:bold;
                    color:rgba(255,255,255,1);
                    line-height:19px;
                    
               }
            }
            >p{
                font-size:24px;
                font-family:MicrosoftYaHei-Bold;
                font-weight:bold;
                color:rgba(51,51,51,1);
                line-height:31px;
                margin: 0px;
                padding-left: 14px;
            }
         }
         >.base-desc-line{
             width:749px;
            height:1px;
            background:rgba(234,234,234,1);
            margin-top: 16px;
         }
         >.base-context{
            font-size:14px;
            font-family:MicrosoftYaHei;
            color:rgba(153,153,153,1);
            line-height:24px;
            margin-top: 12px;
            text-align: left;

         }
         >.base-desc-amount{
             display: flex;
             flex-direction: row;
             padding-top: 17px;
             >.article-amount{
                 display: flex;
                 flex-direction: column;
                 >p:nth-child(1){
                   font-size:40px;
                    font-family:HYk1gj;
                    color:rgba(254,183,5,1);
                    line-height:40px;
                    margin: 0px;
                 }
                >p:nth-child(2){
                    font-size:14px;
                    font-family:MicrosoftYaHei;
                    color:rgba(51,51,51,1);
                    line-height:24px;
                    margin: 0px;
                }
             }
             >.see-amount{
                 display: flex;
                 flex-direction: column;
                 margin-left: 70px;
                 >p:nth-child(1){
                   font-size:40px;
                    font-family:HYk1gj;
                    color:rgba(254,183,5,1);
                    line-height:40px;
                    margin: 0px;
                 }
                >p:nth-child(2){
                    font-size:14px;
                    font-family:MicrosoftYaHei;
                    color:rgba(51,51,51,1);
                    line-height:24px;
                    margin: 0px;
                }
             }
         }
       }
    }
    >.base-center{
        display: flex;
        flex-direction: row;
        margin-top: 40px;
      >p{
          font-size:16px;
          font-family:MicrosoftYaHei;
          color:rgba(51,51,51,1);
          line-height:21px;
          margin: 0;
      }
      >.base-line{
        margin-top: 10px;
        margin-left: 15px;
        width:1099px;
        height:1px;
        background:rgba(234,234,234,1);
      }
    }
    >.base-bottom{
        display: flex;
        flex-direction: row;
        padding-top: 40px;
        >.article-list{
          >.post-card-box {
                  width: 850px;
                  margin-top: -25px;
                    >.post-cards {
                        >:not(:first-child) {
                        border-top: 1px solid rgba(234,234,234,1);
                     }
                    }
                }   
             }
        >.base-bottom-right{
            display: flex;
            flex-direction: column;
            margin-left: 50px;
            >p{
                font-size:16px;
                font-family:MicrosoftYaHei-Bold;
                font-weight:bold;
                color:rgba(51,51,51,1);
                line-height:21px;
                text-align: left;
                margin: 0px 0px 26px 0px;
            }
            >.hot-comment{
                width:280px;
                height: 100%;
               
                
            }
           
        }

    }
}

</style>


